<template>
  <div v-if="task.id > 0"
       class="page-task-detail"
  >
    <div class="content">
      <div class="training-task-info">
        <div class="task-title">{{ task.title }}</div>
        <task-dialog class="task-dialog">
          <ym-content class="task-about"
                      :content="task.about"
          />
          <audio-player v-if="audio"
                        :current="audio.id"
                        :source="audio.source"
                        type="task"
                        :duration="audio.duration"
          />
        </task-dialog>
      </div>

      <div class="voice-dialog-container">
        <task-dialog class="voice-dialog"
                     v-if="localId !== ''"
                     type="primary"
                     direction="right"
        >
          <voice-player class="my-voice"
                        :local-id="localId"
                        :duration="localVoiceDuration"
          />
        </task-dialog>

      </div>
    </div>

    <div class="record-container ym-mw-component-fixed-max"
         v-if="!submittedWork"
    >
      <div class="record-btn">
        <wx-record
          @recording="handleRecording"
          @end="handleRecordEnd"
          @error="handleRecordError"
        />
      </div>
      <ym-button class="training-submit-btn training-submit-btn-primary"
                 :disabled="disabled"
                 size="large"
                 @click="handleSubmitWork"
      >
        打 卡
      </ym-button>
    </div>
  </div>
</template>

<script>
  import { Button, Dialog } from '@ymba/ym-ui';
  import TaskDialog from '@/pages/TrainingTask/components/TaskDialog';
  import Content from '@/components/RichText';
  import AudioPlayer from '@/components/TrainingPlayer/AudioPlayer';
  import VoicePlayer from '@/components/TrainingPlayer/VoicePlayer';
  import WxRecord from '@/components/Record';
  import { commonLog } from '@/services/app';
  import { getTrainingTaskDetail, isTrainingTaskFinish, submitTrainingWork } from '@/services/training';
  import { isWeiXinBrowser } from '@/utils/index';

  export default {
    name: 'PageTrainingTaskDetail',
    metaInfo() {
      return {
        title: this.task.title,
      };
    },
    components: {
      'ym-button': Button,
      TaskDialog,
      'ym-content': Content,
      AudioPlayer,
      VoicePlayer,
      WxRecord,
    },
    data() {
      return {
        levelId: 0,
        recording: false,
        localId: '',
        serverId: '',
        localVoiceDuration: 0,
        disabled: false,
        playing: false,

        audio: null,
        submittedWork: false,
        task: {
          id: 0,
          title: '',
          about: '',
        },
      };
    },
    computed: {
      id() {
        return parseInt(this.$route.params.id, 10);
      },
      icon() {
        return this.playing ? 'stop' : 'play';
      },
    },
    methods: {
      async fetchData(id) {
        const data = await getTrainingTaskDetail(id, 'task');
        this.audio = data.audio;
        this.task = data.task;
      },
      async handleRecordEnd(res) {
        this.localId = res.localId;
        this.localVoiceDuration = res.duration;
        this.recording = false;
      },
      handleRecording() {
        this.localId = '';
        this.recording = true;
      },
      async handleSubmitWork() {
        this.disabled = true;
        if (this.localId === '') {
          this.$toast(this.recording ? '请先完成录音' : '请先录音');
          this.disabled = false;
          return;
        }
        try {
          await this.$dialog.confirm({
            message: '录音提交后将不能修改<br/>是否继续提交？',
            confirmButtonText: '提交',
            closeOnClickOverlay: false,
          });
          try {
            const res = await this.$wechat.uploadVoice(this.localId);
            this.serverId = res.serverId;
          } catch (e) {
            this.$dialog.alert({
              message: '网络出错了，请重新上传',
              confirmButtonText: '好的',
              closeOnClickOverlay: false,
            });
            this.disabled = false;
            return;
          }
          try {
            const data = await submitTrainingWork(this.task.id, this.serverId);
            const route = { name: 'TrainingWorkNotify', params: { id: data.workId } };
            this.submittedWork = true;
            this.$router.push(route);
          } catch (e) {
            this.$dialog.alert({
              message: '网络出错了，请重新提交',
              confirmButtonText: '好的',
              closeOnClickOverlay: false,
            });
            commonLog('submitWorkError', e);
          }
        } catch (e) {
          this.disabled = false;
        }
      },
      handleRecordError() {
        const { id } = this.$route.params;
        this.fetchData(id);
      },
    },
    created() {
      if (!isWeiXinBrowser()) {
        this.$dialog.alert({ message: '请在微信内打开此页面' });
        return;
      }
      const { id } = this.$route.params;
      this.levelId = id;
      this.fetchData(id);
    },
    beforeRouteUpdate(to, from, next) {
      const { id } = to.params;
      this.fetchData(id);
      next();
    },
    async beforeRouteEnter(to, from, next) {
      const data = await isTrainingTaskFinish(to.params.id);
      if (data.render.isFinish) {
        const route = { name: 'TrainingWorkDetail', params: { id: data.work.id }, replace: true };
        next(route);
        return;
      }
      if (!isWeiXinBrowser()) {
        Dialog.alert({ message: '请在微信内打开此页面' });
        return;
      }
      next();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-task-detail {
    height: 100%;
    background: @color-white;
    position: relative;
    overflow-y: scroll;
  }

  .content {
    padding: @size-medium @size-base 482px;
  }

  .task-title {
    margin-bottom: @size-small;
    color: @color-text-base;
    font-weight: @font-weight-primary;
    font-size: @font-size-large;
  }

  .task-dialog {
    padding: @size-base;
    margin-bottom: @size-large;
  }

  .task-about {
    line-height: 1.8;
    letter-spacing: 1px;
    word-wrap: break-word;
  }

  .voice-dialog-container {
    position: relative;
    z-index: @z-index-extra-large;
    display: flex;
    justify-content: flex-end;
    padding-bottom: @size-medium;
  }

  .record-container {
    flex: 1;
    padding: @size-base;
    background: none;
    position: fixed;
    bottom: 0;
  }

  .record-btn {
    margin: 0 auto @size-large;
    text-align: center;
  }

</style>
